export enum JwtGameEngineSupport {
  UNKNOWN = "unknown",
  SUPPORTED = "suppported",
  NOT_SUPPORTED = "not_supported",
}
